import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { PagosFondeadoresService } from '../../../../../services/pagos-fondeadores.service';
import { HelpersService } from '../../../../../services/tools/helpers.service';

@Component({
  selector: 'app-eliminar-pago-modal',
  templateUrl: './eliminar-pago-modal.component.html',
  styleUrls: ['./eliminar-pago-modal.component.scss']
})
export class EliminarPagoModalComponent implements OnInit {

  public errors: any = {};
  public idPago: number = 0;

  constructor(
    private helperService: HelpersService,
    private pagosFondeadoresService: PagosFondeadoresService,
    public dialogRef: MatDialogRef<EliminarPagoModalComponent>,
    @Inject (MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    if(this.data.pago_id != undefined){
      this.idPago = this.data.pago_id;
      console.log("ID Pago: ", this.idPago);
      
    }
  }

  public cerrar(){
    this.dialogRef.close({eliminar:false});
  }

  public aceptar(){
    this.pagosFondeadoresService.deletePago(this.idPago)
     .subscribe(response => {
       const datosPago = response.json();
       if (datosPago.success) {
         this.helperService.notification('Pago eliminado', 'Se ha eliminado exitosamente el pago de inversión seleccionado', 'success');
         this.dialogRef.close({eliminar:true});
         //setTimeout(() => {window.location.reload()},3000);
       }
     }, error => {
       //this.processing = false;
       if(error.status == 400) {
         this.showServicesErrors(error.json().content);
       }else{
         this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
       }
       
       // se resuelven los errores 403 y 500
       this.helperService.httpGlobalError(error, false);
       this.cerrar();
     });
  }

  private showServicesErrors(errors:any[]){
    //Es posible que en algún momento se necesiten parsear los errores ya que las llaves del backend,
    //no correspondan con las llaves de los errores del front
    this.errors = errors;
  }

}



// WEBPACK FOOTER //
// ./src/app/administracion/fondeadores/detalles-inversion/pagos-inversion-modal/eliminar-pago-modal/eliminar-pago-modal.component.ts